<template>
  <span
    class="unit-spinner"
    v-bind="accessibilityAttributes"
    :style="spinnerStyle"
  ></span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: [Number, String],
    default: 24,
  },
  thickness: {
    type: [Number, String],
    default: 2,
  },
  trackColor: {
    type: String,
    default: "rgba(120, 120, 120, 0.2)",
  },
  indicatorColor: {
    type: String,
    default: "#888",
  },
  speed: {
    type: String,
    default: "1s",
  },
  ariaLabel: {
    type: String,
    default: "Loading",
  },
  ariaHidden: {
    type: Boolean,
    default: false,
  },
  role: {
    type: String,
    default: "status",
  },
});

const normaliseLength = (value) => {
  if (typeof value === "number") {
    return `${value}px`;
  }
  if (typeof value === "string") {
    return value;
  }
  return "0px";
};

const spinnerStyle = computed(() => {
  const size = normaliseLength(props.size);
  const thickness = normaliseLength(props.thickness);

  return {
    width: size,
    height: size,
    borderWidth: thickness,
    borderStyle: "solid",
    borderColor: props.trackColor,
    borderTopColor: props.indicatorColor,
    animationDuration: props.speed,
  };
});

const accessibilityAttributes = computed(() => {
  if (props.ariaHidden) {
    return {
      "aria-hidden": "true",
    };
  }

  return {
    role: props.role || "status",
    "aria-label": props.ariaLabel,
  };
});
</script>

<style scoped>
.unit-spinner {
  display: inline-block;
  border-radius: 50%;
  animation-name: unit-spinner-rotate;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes unit-spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .unit-spinner {
    animation: none;
  }
}
</style>
